export default __webpack_public_path__ + "static/media/fb-icon.d0cbd891.svg";